/*global inlineApexAdaptor */
import LCC from "lightning-container";

declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    jsforce: any,
    baseUrl: string
}

const getAction = (action) => {
    let controller = window.inlineApexAdaptor.controller;
    return (controller+'.'+action);
};

let ApexAdapter = (method, route, data, params, headers, callback) => {
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{

        window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('callInternalApi'),
                                                                    method,
                                                                    route,
                                                                    JSON.stringify(data),
                                                                    JSON.stringify(params) || "",
                                                                    JSON.stringify(headers) || "",
                                                                    (result, event) =>{
                                                                        callback(result, event);
                                                                    },
                                                                    config);        
    } catch (e) {
        console.log('e:',e);
    }
};

let SampleApexAdapter = (method, route, data, params, headers, callback) => {
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{

        window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('callSampleInternalApi'),
                                                                    method,
                                                                    route,
                                                                    JSON.stringify(data),
                                                                    JSON.stringify(params) || "",
                                                                    JSON.stringify(headers) || "",
                                                                    (result, event) =>{
                                                                        callback(result, event);
                                                                    },
                                                                    config);        
    } catch (e) {
        console.log('e:',e);
    }
};

const getParam = (name) => {
    return decodeURI(
        (RegExp(name+"=(.+?)(&|$)").exec(window.location.search)||['',''])[1]
    );
};
const prepareInlineAdapter = () => {
    let callbacks = {};
    var sessionId = LCC.getRESTAPISessionKey();
    if(typeof(window.inlineApexAdaptor) !== 'undefined' && (!sessionId || sessionId === "null" || sessionId.length <= 0)){
        return null;
    }

    var landingResources = decodeURIComponent(getParam("landingResources"));
    if(!landingResources || landingResources === "null"){
        landingResources = '';
    }
    var resources = decodeURIComponent(getParam("resources"));
    if(!resources || resources === "null"){
        resources = '';
    }
    window.inlineApexAdaptor = {
        'Visualforce': {
            'remoting': {
                'Manager': {
                    'invokeAction': function(remoteAction, method, route, data, params, headers, callback){
                        const callbackId = Math.random().toString(36).substr(2, 9); //Generate random identity for callback function avoid any conflict with multiple calls.
                        callbacks[callbackId] = callback; //Register callback with callback id so that we know which callback function to call when we receive response from controller.
                        let remoteActionArray = remoteAction.split(".");
                        let action = remoteAction;
                        if(remoteActionArray.length > 1){
                            action = remoteActionArray[1];
                        }
                        LCC.sendMessage({ //Send message to controller to call action.
                            action: action,
                            params: {
                                method: method,
                                requestURI: route,
                                requestEntityStr: data,
                                params: params,
                                headers: headers,
                            },
                            callbackId: callbackId
                        });
                    },
                    'invokeCustomAction': function(remoteAction, params, callback){
                        const callbackId = Math.random().toString(36).substr(2, 9); //Generate random identity for callback function avoid any conflict with multiple calls.
                        callbacks[callbackId] = callback; //Register callback with callback id so that we know which callback function to call when we receive response from controller.
                        let remoteActionArray = remoteAction.split(".");
                        let action = remoteAction;
                        if(remoteActionArray.length > 1){
                            action = remoteActionArray[1];
                        }
                        LCC.sendMessage({ //Send message to controller to call action.
                            action: action,
                            params: params,
                            callbackId: callbackId
                        });
                    }
                }
            }
        },
        'callInternalApi': 'c.callInternalApi',
        'callSampleInternalApi': 'c.callSampleInternalApi',
        'saveContentVersion': 'c.saveContentVersion',
        'getContentVersion': 'c.getContentVersion',
        'getAttachment': 'c.getAttachment',
        'saveAttachment': 'c.saveAttachment',
        'resources': resources, //For app icons hosted in static resources.
        'landingResources': landingResources, //For app assets other than icons.
        'page': getParam("page"), //Page received through lightning container url.
        'sessionId': sessionId,
        'bundleDomain': getParam("bundleDomain"),
        'baseUrl': '',
        'controller': ''
    };

    LCC.addMessageHandler((response) => { //Listen for messages received from controller and call appropriate callback function registered during initial call.
        const data = response.data;
        const callbackId = response.callbackId;
        callbacks[callbackId](data);
        delete callbacks[callbackId];
    });
};

const getSessionId = () => {
    var sessionId = LCC.getRESTAPISessionKey();
    if(typeof(sessionId) === "string" && sessionId.length > 0){
        return sessionId;
    }
    if(typeof(window.inlineApexAdaptor.sessionId) !== 'undefined'){
        return window.inlineApexAdaptor.sessionId;
    }
    return "";
};

const loginAdapter = (requestData, callback) => {
    // mountApexAdapter();
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{

        window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('login'),
                                                                    JSON.stringify(requestData),
                                                                    (result, event) =>{
                                                                        callback(result, event);
                                                                    },
                                                                    config);        
    } catch (e) {
        console.log('e:',e);
        //alert(e.message);
    }
};

const registerAdapter = (firstName, lastName, email, password, confirmPassword, communityNickname, callback) => {
    // mountApexAdapter();
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{

        window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('registerUser'),
                                                                    firstName,
                                                                    lastName,
                                                                    email,
                                                                    password,
                                                                    confirmPassword,
                                                                    communityNickname,
                                                                    (result, event) =>{
                                                                        callback(result, event);
                                                                    },
                                                                    config);        
    } catch (e) {
        console.log('e:',e);
        //alert(e.message);
    }
};

const saveAttachment = (parentId, fileName, base64Data, contentType, fileId, callback) => {
    // mountApexAdapter();
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{
        const remotingManager = window.inlineApexAdaptor.Visualforce.remoting.Manager;
        if(typeof(remotingManager.invokeCustomAction) === "function"){
            const params = {
                parentId: parentId,
                fileName: fileName,
                base64Data: base64Data,
                contentType: contentType,
                fileId: fileId,
            }
            remotingManager.invokeCustomAction(getAction('saveAttachment'), params,
                (result, event) =>{
                    callback(result, event);
                },
                config);
        }else{
            remotingManager.invokeAction(getAction('saveAttachment'), parentId, fileName, base64Data, contentType, fileId,
                (result, event) =>{
                    callback(result, event);
                },
                config);
        }        
    } catch (e) {
        console.log('e:',e);
        //alert(e.message);
    }
};

const saveContentVersion = (fileName, base64Data, fileId, callback, recordId = null) => {
    // mountApexAdapter();
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{
        const remotingManager = window.inlineApexAdaptor.Visualforce.remoting.Manager;
        if(typeof(remotingManager.invokeCustomAction) === "function"){
            const params = {
                fileName: fileName,
                base64Data: base64Data,
                fileId: fileId
            };
            if(recordId !== null){
                params['recordId'] = recordId;
            }
            remotingManager.invokeCustomAction(getAction('saveContentVersion'), params,
                (result, event) =>{
                    callback(result, event);
                },
                config);
        }else{
            window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('saveContentVersion'), fileName, base64Data, fileId, recordId,
                (result, event) =>{
                    callback(result, event);
                },
                config); 
        }
               
    } catch (e) {
        console.log('e:',e);
        //alert(e.message);
    }
};

const getContentVersion = (fileId, callback) => {
    // mountApexAdapter();
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{
        const remotingManager = window.inlineApexAdaptor.Visualforce.remoting.Manager;
        if(typeof(remotingManager.invokeCustomAction) === "function"){
            const params = {
                fileId: fileId,
            }
            remotingManager.invokeCustomAction(getAction('getContentVersion'), params,
                (result, event) =>{
                    callback(result, event);
                },
                config);
        }else{
            window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('getContentVersion'), fileId,
                (result, event) =>{
                    callback(result, event);
                },
                config); 
        }
               
    } catch (e) {
        console.log('e:',e);
        //alert(e.message);
    }
};

const getAttachment = (fileId, callback) => {
    // mountApexAdapter();
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{
        const remotingManager = window.inlineApexAdaptor.Visualforce.remoting.Manager;
        if(typeof(remotingManager.invokeCustomAction) === "function"){
            const params = {
                fileId: fileId,
            }
            remotingManager.invokeCustomAction(getAction('getAttachment'), params,
                (result, event) =>{
                    callback(result, event);
                },
                config);
        }else{
            window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('getAttachment'), fileId,
                (result, event) =>{
                    callback(result, event);
                },
                config); 
        }
    } catch (e) {
        console.log('e:',e);
        //alert(e.message);
    }
};

const loginWithCodeAdapter = (email, callback) => {
    // mountApexAdapter();
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{

        window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('emailLogin'),
                                                                    email,
                                                                    (result, event) =>{
                                                                        callback(result, event);
                                                                    },
                                                                    config);        
    } catch (e) {
        console.log('e:',e);
        //alert(e.message);
    }
};

const signupWithCodeAdapter = (email, callback) => {
    // mountApexAdapter();
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{

        window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('registerUserEmail'),
                                                                    email,
                                                                    (result, event) =>{
                                                                        callback(result, event);
                                                                    },
                                                                    config);        
    } catch (e) {
        console.log('e:',e);
        //alert(e.message);
    }
};

const leadAdapter = (firstName, lastName, email, company, callback) => {
    // mountApexAdapter();
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{

        window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('createLead'),
                                                                    firstName,
                                                                    lastName,
                                                                    email,
                                                                    company,
                                                                    (result, event) =>{
                                                                        callback(result, event);
                                                                    },
                                                                    config);        
    } catch (e) {
        console.log('e:',e);
        //alert(e.message);
    }
};

const getBaseUrl = () => {
    if(process.env.NODE_ENV === "test"){
        return "";
    }
    if(typeof(window.inlineApexAdaptor) === "undefined"){
        return "";
    }
    let baseUrl = "";
    if(typeof(window.inlineApexAdaptor.baseUrl) === 'string' && window.inlineApexAdaptor.baseUrl !== "null"){
        baseUrl = window.inlineApexAdaptor.baseUrl;
    }
    if(window.inlineApexAdaptor.hasOwnProperty("rte")){
        let returnUrl = window.inlineApexAdaptor.rte;
        returnUrl = returnUrl.replace("System.PageReference[", "");
        returnUrl = returnUrl.replace("]", "");
        returnUrl = returnUrl.split("?")[0];
        if(returnUrl.length > 0){
            baseUrl = baseUrl.replace(returnUrl, "");
        }
    }
    baseUrl = baseUrl.replace(/^\/+/g, ''); //Remove leading slash
    if(baseUrl.length > 0 && baseUrl.charAt(0) !== "/"){
        baseUrl = "/"+baseUrl;
    }
    baseUrl = baseUrl.replace(/\/$/, '');
    return baseUrl;
}

function getCurrentPage(){
    let page = window.location.pathname;
    let baseUrl = getBaseUrl();
    const secureLink = getParam("secureLink");
    if(typeof(secureLink) === "string" && secureLink.length > 0 && secureLink !== "null"){
        window.inlineApexAdaptor.page = "auth/login-link";
        window.inlineApexAdaptor.sessionId = secureLink;
        localStorage.setItem("login_type", "link");
    }
    if(window.location.hash.length > 32){
        window.inlineApexAdaptor.page = "auth/login-microsoft";
    }
    if(typeof(window.inlineApexAdaptor.page) === 'string' && window.inlineApexAdaptor.page !== "null"){
        page = baseUrl+"/"+window.inlineApexAdaptor.page;
        if(baseUrl !== window.location.pathname && (baseUrl+'/') !== window.location.pathname){
            page = window.location.pathname;
        }
    }
    if(window.inlineApexAdaptor.hasOwnProperty("rte")){
        let returnUrl = window.inlineApexAdaptor.rte;
        returnUrl = returnUrl.replace("System.PageReference[", "");
        returnUrl = returnUrl.replace("]", "");
        returnUrl = returnUrl.split("?")[0];
        returnUrl = returnUrl.replace(/^\/+/g, ''); //Remove leading slash
        if(returnUrl.length > 0){
            window.inlineApexAdaptor.page = returnUrl;
            page = baseUrl+"/"+returnUrl;
        }
    }
    return page;
}

const pdfDataAdapter = (callback) => {
    // mountApexAdapter();
    let config = { 
        buffer: true, 
        escape: false, 
        timeout: 30000
    }
    try{
        window.inlineApexAdaptor.Visualforce.remoting.Manager.invokeAction(getAction('getPDFData'),                                                                    
                                                                    (result, event) =>{
                                                                        callback(result, event);
                                                                    },
                                                                    config);        
    } catch (e) {
        console.log('e:',e);
        //alert(e.message);
    }
};

export { ApexAdapter, prepareInlineAdapter, getSessionId, saveAttachment, saveContentVersion, loginAdapter, registerAdapter, 
    getContentVersion, getAttachment, SampleApexAdapter, loginWithCodeAdapter, signupWithCodeAdapter, leadAdapter, getParam,
    getBaseUrl, pdfDataAdapter, getCurrentPage };

export default ApexAdapter;